:root {
    --colors-gray-800: "#1f2937";
}

.container {
    background-color: white;
    box-shadow: black 0 0 10px;
}

.body {
    padding: 12px;
}

.bodySpacer {
    display: flex;
    padding-top: 1px;
    padding-bottom: 1px;
    justify-content: space-between;
}

.topBar {
    background-color: var(--color-blue-violet);
    width: 100%;
    padding: 2px;
}

.spacer{
    display: flex;
    justify-content: space-between;
}

.patientName{
    font-size: 20px;
    font-weight: 400;
    color: white;
    padding-left: 4px;
    display: flex;
}

.date {
    font-size: 20px;
    font-weight: 400;
    color: hsla(0, 0%, 100%, 0.7);
    padding-left: 4px;
    margin-bottom: 4px;
}




.circle{
    background-color: var(--color-gray-200);
    cursor: pointer;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin: 3px;
}

.checkBoxBar{
    display: flex;
    padding: 4px 4px;
    justify-content: space-around;
    background-color: var(--color-blue-violet-light);
    border-style: solid;
    border-width: 2px;
    border-color: var(--color-gray-200);
    margin-top: 17px;
    margin-bottom: 4px;
    border-Radius: 4px;
}

.checkBox{
    margin-inline-end: 4px;
    accent-color: var(--color-blue-violet);
}


.icon {
    width: 25px;
    height: 25px;
    stroke: var(--color-blue-violet);
}

.buttonIcon {
    width: 1.5em;
    height: 1.5em;
    filter: invert(1);
    margin-inline-end: 4px;
}

.button {
    padding: 10px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;
    margin-left: 6px;
    margin-right: 6px;
    display: flex;
}

.colorDanger {
    color: white;
    background-color: red;
}

.colorProceed {
    color: white;
    background-color: darkblue;
}

.buttonGroup {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 10px;
}

.input {
    border-width: 2px;
    border-Color: var(--color-gray-200);
    border-radius: 4px;
    padding: 0.3rem 0.5rem;
    width: 100%;
    /*background-color: var(--color-blue-violet-light);*/
}



.flex{
    display: flex;
}

.marginEnd{
    margin-inline-end: 4px;
}

.formLabel{
    font-family: OpenSans, sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 1px;
    margin-left: 2px;
}

.clickable{
    cursor: pointer;
}

.formLabel:disabled{
    color: var(--color-gray-400);
    cursor: not-allowed;
}